<div
  class="home-feed-list"
  appPullToRefresh
  [pullToRefreshDisabled]="isSwipePreview"
  #ptr="appPullToRefresh"
  (refresh)="onPullToRefresh(ptr)"
>
  <ng-container *ngIf="visibleFeeds.length || !isSwipePreview">
  <p-dataView
    [value]="visibleFeeds"
    [rows]="pageSize"
    [totalRecords]="totalRecords"
    [lazy]="!isSwipePreview"
    [paginator]="!isSwipePreview"
    [alwaysShowPaginator]="false"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="loadNextFeedsChunk($event)"
    [emptyMessage]="'common.no_results' | translate"
  >
    <ng-template let-feeds pTemplate="list">
      <div *ngFor="let feed of feeds; index as i" class="col-12 p-0 m-0 mb-2">
        <app-feed-card
          [feed]="feed"
          [lcpPriority]="prioritizeInitialCards && i < 2"
          [mediaDeferred]="isSwipePreview && !previewMediaEnabled"
        ></app-feed-card>
      </div>
    </ng-template>
  </p-dataView>
  </ng-container>
</div>
